import { Injectable } from '@angular/core';

import { ReleaseNote } from '../release-note/model/release-note.model';
import { Constants } from 'src/app/dashboards/dashboard/constants';
import { ReleaseNoteService } from '../release-note/release-note.service';
import { AutenticacaoService } from '../autenticacao.service';
import { Duracao, ToasterService } from 'src/app/core/framework/toaster/toaster.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {
  constructor(
    private autenticacaoService: AutenticacaoService,
    private toasterService: ToasterService,
    private releaseNoteService: ReleaseNoteService
  ) {}
  
  public initVersionCheck() {
    setTimeout(() => this.checkVersion(true), 2000);

    const frequencia = (1000 * 60 * environment.intervalo_em_minutos_do_version_check);
    setInterval(() => {
        this.checkVersion(false);
    }, frequencia);
  }

  private checkVersion(checkVersionInicial: boolean) {
    if ( !this.autenticacaoService.usuarioEstaLogado() ) {
      return;
    }

    this.releaseNoteService
        .buscarUltimaReleaseNote()
        .subscribe(
            (releaseNote: ReleaseNote) => {
                const versaoWebUiDaAPI = releaseNote.versaoWebUi;
                const versaoWebUiDoCookie = localStorage.getItem(Constants.versaoWebUiStorageKey);
                // const versaoWebUiDoPackageJson = require('./package.json').version;
                // console.log(`chk.vr: api_${versaoWebUiDaAPI} ck_${versaoWebUiDoCookie}`);

                const hashChanged = (versaoWebUiDoCookie !== versaoWebUiDaAPI);

                if (hashChanged) {
                  // era aqui

                  if ( releaseNote.logout === true ) {
                    this.toasterService
                        .info(
                          'Atualização do sistema', 
                          'Esta atualização em especial exige logout. Você será desconectado automaticamente.', Duracao.MUITO_DEMORADO
                        );

                    setTimeout(() => {
                      // se exigiu logout, salvar nova versao no cookie apenas após o comando de logout
                      // o usuario pode reiniciar a tela e acabar nao realizando o logout
                      localStorage.setItem(Constants.versaoWebUiStorageKey, versaoWebUiDaAPI);

                      this.autenticacaoService.logout();
                      
                      setTimeout(() => this.toasterService.info('Atualização do sistema', 'Esta atualização em especial exigiu o seu logout automático', Duracao.FIXO), 2000);
                    }, Duracao.MUITO_DEMORADO.valueOf());
                  }
                  else {
                    // se nao exigir logout, pode salvar na nova versao 
                    localStorage.setItem(Constants.versaoWebUiStorageKey, versaoWebUiDaAPI);

                    if ( !checkVersionInicial ) {
                      this.toasterService.info('Atualização do sistema', 'É recomendável salvar o trabalho. A página será recarregada', Duracao.DEMORADO);
                      setTimeout(
                        () => location.reload()
                        , Duracao.DEMORADO.valueOf()
                      );
                    }
                  }
                }
            },
            (err) => {
              console.error(err, 'Não foi possível recuperar a versão');
            }
        );
  }
}
